/**
 * WireScript Schema v2 - Registry
 *
 * Central registry of all element schemas with type inference.
 */
import { avatar, badge, box, breadcrumb, button, card, chart, crumb, datepicker, divider, dropdown, empty, footer, form, group, header, icon, image, input, list, metric, navElement, progress, scroll, section, skeleton, slot, tab, tabs, text, toast, tooltip, } from './elements.js';
import { bool, num } from './props.js';
// =============================================================================
// Schema Registry
// =============================================================================
export const ELEMENTS = {
    // Containers (10)
    box,
    card,
    section,
    header,
    footer,
    nav: navElement,
    form,
    list,
    scroll,
    group,
    // Content (6)
    text,
    icon,
    image,
    avatar,
    badge,
    divider,
    // Interactive (2)
    button,
    dropdown,
    // Inputs (2)
    input,
    datepicker,
    // Data (4)
    metric,
    progress,
    chart,
    skeleton,
    // Navigation (4)
    tabs,
    tab,
    breadcrumb,
    crumb,
    // Utility (4)
    tooltip,
    toast,
    empty,
    slot,
};
/** Array of all registered element type names */
export const ELEMENT_TYPE_LIST = Object.keys(ELEMENTS);
// =============================================================================
// Runtime Lookup
// =============================================================================
/**
 * Get schema for an element type.
 * Returns undefined if type is not a built-in element.
 */
export function getSchema(type) {
    const schema = ELEMENTS[type];
    if (!schema)
        return undefined;
    return {
        type: schema.type,
        content: schema.content,
        children: schema.children,
        props: schema.props,
    };
}
/**
 * Check if a type is a built-in element.
 */
export function isBuiltinElement(type) {
    return type in ELEMENTS;
}
// =============================================================================
// Overlay Schema
// =============================================================================
/** Overlay props schema */
export const OVERLAY_PROPS = {
    id: { type: 'string' },
    gap: num(0),
    padding: num(0),
    width: { type: 'any' },
    height: { type: 'any' },
    title: { type: 'string' },
    position: { type: 'symbol' },
    // Position flags
    top: bool(),
    bottom: bool(),
    left: bool(),
    right: bool(),
    open: bool(),
};
//# sourceMappingURL=registry.js.map